import api from '../api/axios';

export interface QuotationItem {
  id?: number;
  quotation?: number;
  product?: number | null;
  description?: string;
  quantity: number;
  unitPrice: number;
  discount?: number;
  tax?: number;
  total: number;
}

export interface Quotation {
  id?: number;
  quotationNumber: string;
  customer?: number;
  insuranceClient?: number;
  date: string;
  validUntil?: string;
  subtotal: number;
  tax: number;
  discount: number;
  total: number;
  status?: 'draft' | 'sent' | 'accepted' | 'rejected' | 'expired';
  notes?: string;
  termsAndConditions?: string;
  createdBy?: number;
}

const QuotationService = {
  getAll: (params?: any) => api.get('/quotations', { params }),
  getOne: (id: number, params?: any) => 
    api.get(`/quotations/${id}`, { 
      params: params || { populate: ['customer', 'insuranceClient', 'createdBy'] } 
    }),
  create: (data: Quotation) => api.post('/quotations', { data }),
  update: (id: number, data: Partial<Quotation>) => 
    api.put(`/quotations/${id}`, { data }),
  delete: (id: number) => api.delete(`/quotations/${id}`),
  
  // Quotation Items
  getItems: (quotationId: number) =>
    api.get('/quotation-items', {
      params: {
        'filters[quotation][id][$eq]': quotationId,
        populate: 'product',
      },
    }),
  createItem: (data: QuotationItem) => api.post('/quotation-items', { data }),
  updateItem: (id: number, data: Partial<QuotationItem>) =>
    api.put(`/quotation-items/${id}`, { data }),
  deleteItem: (id: number) => api.delete(`/quotation-items/${id}`),
};

export default QuotationService;

